import clsx from "clsx";
import styles from "./letter.module.scss";

export default function Letter(props) {
    const {
        tile,
        navigationMode,
        keyboardChain
    } = props;

  const isInKeyboardChain = keyboardChain.find((it) => it.id === tile.id);


    return (
        <div
            className={clsx(styles.letter,
                navigationMode && styles.keyboardMode,
                isInKeyboardChain && styles.activeKeyboard
            )}
        >
            <p>{tile.letter}</p>
        </div>
    );
}